import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modaal, Buttton } from "../../components";
import { actionCommon } from "../../redux/actions";
import { Commons } from "../../utilities";
import { useLocation, useNavigate } from "react-router-dom";
import { useModal } from "../../contexts";
import { useDispatch } from "react-redux";
import { FaHospitalUser } from "react-icons/fa";

const OtpCommonPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { showModal, hideModal } = useModal();
  useEffect(() => {
  }, [location]);
  const txtContent = {
    title: (
      <div className="mTitleBlk">
        <h2 className="mTitle">{t("otpPage.title")}</h2>
        <p className="mSubTitle">
          {`${t("otpPage.subTitle1")}  ${Commons.maskEmail(
            location.state?.email
          )} ${t("otpPage.subTitle2")}`}
        </p>
      </div>
    ),
    contents: {
      content: t("otpPage.didnt_get"),
    },
    childrens: {
      children1: t("resend_otp"),

      children2: t("verify"),
    },
  };
  const [showModal1] = useState(true);
  const handleCloseModal = () => {
    navigate("/");
  };
  const [credentials, setCredentials] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
  });

  const [errors, setErrors] = useState({});

  const validationRules = {
    otp: { required: true, minLength: 6, maxLength: 6 },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;


    if (value.length <= 1 && /^[0-9]*$/.test(value)) {

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));

      setCredentials((prevCredentials) => ({
        ...prevCredentials,
        [name]: value,
      }));

      const fieldIndex = parseInt(name.replace("otp", ""), 10);
      const nextField = document.querySelector(`[name=otp${fieldIndex + 1}]`);
      if (nextField) {
        nextField.focus();
      }
    }
  };
  const handleSubmit = () => {
    const otp = Object.values(credentials).join("");
    const validationErrors = Commons.validate({ otp }, validationRules);

    const passingData = {
      userId: location.state?.userId,
      otp: otp,
    };

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      dispatch(
        actionCommon.verifyOtp(passingData, (error, response) => {
          if (error) {
         
          } else {
            if (response) {
              if (response.status === 200) {
                if (location.state?.UserType === Commons.userType.doctor) {
                  navigate("/doctor/login");
                } else if (
                  location.state?.UserType === Commons.userType.patient
                ) {
                  showModal({
                    title: (
                      <div className="message-modal-title-blk">
                        <FaHospitalUser />
                        <p className="exado-title-four">{t("success")}</p>
                      </div>
                    ),
                    bodyContent: (
                      <div>
                        {" "}
                        {Commons.maskEmail(location.state?.email)}
                        <p className="mt-2">{t("otpPage.success_message")}</p>
                      </div>
                    ),
                    autoClose: 5000,
                    footer: (
                      <Buttton.Buttton
                        children={t("okay")}
                        className="btn-solid-Aqua_Teal"
                        onClick={hideModal}
                      />
                    ),
                    className: "message-modal",
                  });
                  navigate("/patient/login");
                }
              }
            }
          }
        })
      );
    }
  };

  const inputFields = Array.from({ length: 6 }, (_, i) => ({
    type: "text",
    placeholder: "X",
    name: `otp${i + 1}`,
    maxLength: 1,
    md: 1,
  }));
  const footer = (
    <>
      <div className="modal-footer-blk">
        <div className="d-flex align-items-center">
          <div className="modal-footer-txt">{txtContent.contents.content}</div>
          <Buttton.Buttton
            children={txtContent.childrens.children1}
            className="btn-border-Aqua_Teal"
          />{" "}
        </div>
        <Buttton.Buttton
          children={txtContent.childrens.children2}
          onClick={handleSubmit}
          className="btn-solid-Aqua_Teal"
        />
      </div>
    </>
  );

  return (
    <div>
      <Modaal.OtpModal
        show={showModal1}
        onHide={handleCloseModal}
        credentials={credentials}
        handleChange={handleChange}
        title={txtContent.title}
        inputFields={inputFields}
        footer={footer}
        errors={errors}
        className="auth-modal verify-otp-modal"
      />
    </div>
  );
};

export default OtpCommonPage;
